import { createElementVNode as _createElementVNode, normalizeClass as _normalizeClass, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createCommentVNode as _createCommentVNode, resolveComponent as _resolveComponent, createBlock as _createBlock, createVNode as _createVNode, withCtx as _withCtx, resolveDirective as _resolveDirective, withDirectives as _withDirectives } from "vue"

const _hoisted_1 = { class: "relative" }
const _hoisted_2 = /*#__PURE__*/_createElementVNode("path", { d: "M12 12q-1.65 0-2.825-1.175Q8 9.65 8 8q0-1.65 1.175-2.825Q10.35 4 12 4q1.65 0 2.825 1.175Q16 6.35 16 8q0 1.65-1.175 2.825Q13.65 12 12 12Zm-8 8v-2.8q0-.85.438-1.563.437-.712 1.162-1.087 1.55-.775 3.15-1.163Q10.35 13 12 13t3.25.387q1.6.388 3.15 1.163.725.375 1.162 1.087Q20 16.35 20 17.2V20Z" }, null, -1)
const _hoisted_3 = [
  _hoisted_2
]
const _hoisted_4 = { class: "px-4 py-3" }
const _hoisted_5 = { class: "mb-4 flex items-center space-x-3" }
const _hoisted_6 = {
  key: 0,
  class: "text-dark"
}
const _hoisted_7 = { class: "flex flex-col space-y-2" }
const _hoisted_8 = { class: "flex cursor-pointer items-center justify-between bg-slate-50 py-1 pl-2" }
const _hoisted_9 = /*#__PURE__*/_createElementVNode("p", { class: "text-dark" }, "Development", -1)

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_the_button = _resolveComponent("the-button")!
  const _component_vue_toggle = _resolveComponent("vue-toggle")!
  const _component_dropdown_wrapper = _resolveComponent("dropdown-wrapper")!
  const _directive_click_away = _resolveDirective("click-away")!

  return _withDirectives((_openBlock(), _createElementBlock("div", _hoisted_1, [
    (_openBlock(), _createElementBlock("svg", {
      class: _normalizeClass(`cursor-pointer fill-darkgrey hover:fill-primary ${
        _ctx.isUserDropdownOpened && 'fill-primary'
      }`),
      height: "24",
      width: "24",
      xmlns: "http://www.w3.org/2000/svg",
      onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.openUserDropdown && _ctx.openUserDropdown(...args)))
    }, _hoisted_3, 2)),
    _createVNode(_component_dropdown_wrapper, { "is-dropdown-opened": _ctx.isUserDropdownOpened }, {
      default: _withCtx(() => [
        _createElementVNode("div", _hoisted_4, [
          _createElementVNode("div", _hoisted_5, [
            (!_ctx.isLocal)
              ? (_openBlock(), _createElementBlock("p", _hoisted_6, _toDisplayString(_ctx.user.email), 1))
              : _createCommentVNode("", true)
          ]),
          _createElementVNode("div", _hoisted_7, [
            (!_ctx.isLocal)
              ? (_openBlock(), _createBlock(_component_the_button, {
                  key: 0,
                  "full-width": true,
                  icon: ['fas', 'user-edit'],
                  text: _ctx.$t('UserDropdown.EditProfile'),
                  size: "sm",
                  variant: "outline",
                  onExecuteMethod: _ctx.goToKeycloakProfile
                }, null, 8, ["text", "onExecuteMethod"]))
              : _createCommentVNode("", true),
            (!_ctx.isLocal)
              ? (_openBlock(), _createBlock(_component_the_button, {
                  key: 1,
                  "full-width": true,
                  icon: ['fas', 'sign-out-alt'],
                  "is-loading": _ctx.isLoggingOut,
                  text: _ctx.$t('UserDropdown.Logout'),
                  size: "sm",
                  onExecuteMethod: _ctx.logout
                }, null, 8, ["is-loading", "text", "onExecuteMethod"]))
              : _createCommentVNode("", true),
            _createElementVNode("div", _hoisted_8, [
              _hoisted_9,
              _createVNode(_component_vue_toggle, {
                "active-color": '#007cc1',
                toggled: _ctx.moduleToggleStore.isDevelopment,
                name: "ParkingManager",
                onToggle: _cache[1] || (_cache[1] = ($event: any) => (_ctx.moduleToggleStore.toggleDevelopment()))
              }, null, 8, ["toggled"])
            ])
          ])
        ])
      ]),
      _: 1
    }, 8, ["is-dropdown-opened"])
  ])), [
    [_directive_click_away, _ctx.isUserDropdownOpened && _ctx.openUserDropdown]
  ])
}